export default [
  {
    project_name: "AndKasir",
    project_description:
      "Kasir Application based on Java. Simple feature but powerful",
    project_image_url:
      "https://res.cloudinary.com/andriawan/image/upload/w_500/v1583851577/images/about.png",
    project_url: "https://github.com/andriawan/andkasir.git"
  },

  {
    project_name: "AndKamus",
    project_description:
      "Indonesia - English Dictionary based on C++. Very light and powerful. Terminal based App.",
    project_image_url:
      "https://res.cloudinary.com/andriawan/image/upload/w_500/v1583851582/images/help.png",
    project_url: "https://github.com/andriawan/AndKamus"
  },
  {
    project_name: "Trucking System",
    project_description:
      "Trucking System Services Administration which is built with Codeigniter Framework",
    project_image_url:
      "https://res.cloudinary.com/andriawan/image/upload/w_500/v1583851614/images/upw.png",
    project_url: "http://trucking-ci.herokuapp.com/"
  },
  {
    project_name: "AndDrive",
    project_description: "Web Apps as Wrapper Upload to Google Drive.",
    project_image_url:
      "https://res.cloudinary.com/andriawan/image/upload/w_500/v1583851576/images/anddrive.png",
    project_url: "http://anddrive.herokuapp.com/"
  },
  {
    project_name: "AndCalc",
    project_description: "Simple Calculator Made With Vue JS 2.0",
    project_image_url:
      "https://res.cloudinary.com/andriawan/image/upload/w_500/v1583851575/images/andcalc.png",
    project_url: "https://vue.andriawan.com/and-calc"
  },
  {
    project_name: "AndDataConverter",
    project_description: "Simple Data Converter Made With ReactJS",
    project_image_url:
      "https://res.cloudinary.com/andriawan/image/upload/w_500/v1583851584/images/andataconvrter.png",
    project_url: "https://react.andriawan.com/and-converter/"
  }
];
